let API_BASE_URL;

const hostname = window.location.hostname;

if (hostname === "localhost" || hostname === "127.0.0.1") {
  API_BASE_URL = "http://localhost:5000";
} else if (hostname.includes("staging")) {
  API_BASE_URL = "https://staging.api.kim-anh-atelier.fr";
} else {
  API_BASE_URL = "https://api.kim-anh-atelier.fr";
}

const config = {
  API_BASE_URL,
};

export default config;
